import React, { useEffect, useState, useContext } from "react";
import * as CONST from "../config/Constant";
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import ReadPolicies from "../../pages/admin/policy/ReadPolicies";
import axios from 'axios';

function AuthMenu() {
  const [eventStatus, setEventStatus] = useState("");
  const [dptStatus, setDptStatus] = useState(0);
  const [empStatus, setEmpStatus] = useState(0);
  const [policyStatus, setPolicyStatus] = useState(0);
  const [openingStatus, setOpeningStatus] = useState(0);
  const [birthdayStatus, setBirthdayStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [leaveStatus, setLeaveStatus] = useState(0);
  const [hrdStatus, setHrdStatus] = useState(0);
  const [supportStatus, setSupportStatus] = useState(0);
  const [libraryStatus, setLibraryStatus] = useState(0);
  const [exemptionStatus, setExemptionStatus] = useState(0);
  const [settingStatus, setSettingStatus] = useState(0);
  const [assetsStatus, setAssetsStatus] = useState(0);
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const [acceptedTerms, setAcceptedTerms] = useState(0);
  let department_id = '';
  let isToken = "";
  let is_head = 0;
  let is_admin = 0;
  let hr_head = 0;
  let portal_permissions = '';
  //let accepted_terms_and_conditions = 0;
  if (authUserData) {
    /*  console.log(authUserData[0]); */
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
      department_id = authUserData[0].department_id ? authUserData[0].department_id : "";
      is_head = authUserData[0].is_head ? authUserData[0].is_head : 0;
      is_admin = authUserData[0].is_admin ? authUserData[0].is_admin : 0;
      hr_head = authUserData[0].hr_head ? authUserData[0].hr_head : 0;
      portal_permissions = authUserData[0].permissions ? authUserData[0].permissions : '';
      //accepted_terms_and_conditions = authUserData[0].accepted_terms_and_conditions ? authUserData[0].accepted_terms_and_conditions : 0;
      console.log("accepted_terms_and_conditions from context: " + authUserData[0].accepted_terms_and_conditions);
      // console.log("portal_permissions from context: " + portal_permissions);
      console.log("is head from context: " + is_head);
      console.log("is admin from context: " + is_admin);
      console.log("library status from context:" + portal_permissions.libraryStatus);


    }
  }
  async function checkPermitions(portal_permissions) {
    if (portal_permissions) {
      portal_permissions = JSON.parse(portal_permissions);
      setEventStatus(portal_permissions ? portal_permissions.eventStatus : 0);
      setDptStatus(portal_permissions ? portal_permissions.dptStatus : 0);
      setEmpStatus(portal_permissions ? portal_permissions.empStatus : 0);
      setPolicyStatus(portal_permissions ? portal_permissions.policyStatus : 0);
      setOpeningStatus(portal_permissions ? portal_permissions.openingStatus : 0);
      setBirthdayStatus(portal_permissions ? portal_permissions.birthdayStatus : 0);
      setHrdStatus(portal_permissions ? portal_permissions.hrdStatus : 0);
      setEmpStatus(portal_permissions ? portal_permissions.empStatus : 0);
      setSupportStatus(portal_permissions ? portal_permissions.supportStatus : 0);
      setLibraryStatus(portal_permissions ? portal_permissions.libraryStatus : 0);
      console.log("libraryStatus from backend:", portal_permissions.libraryStatus);
      setExemptionStatus(portal_permissions ? portal_permissions.exemptionStatus : 0);
      setAssetsStatus(portal_permissions ? portal_permissions.assetsStatus : 0);
      setSettingStatus(portal_permissions ? portal_permissions.settingStatus : 0);
    }
    console.log("libraryStatus from backend outside:", portal_permissions.libraryStatus);
  }
  useEffect(() => {
    checkPermitions(portal_permissions);
    // Fetch pending approvals count
    if (isToken && (is_head == '1' || is_admin == '1')) {
      const uid = authUserData?.[0]?.user_id || '';
      axios.post(CONST.GET_NOTIFICATION_COUNTS, {
        user_id: uid, is_admin, is_head, department_id
      }, { headers: { Authorization: `Bearer ${isToken}` } })
      .then(res => { if (res.data.status === 'success') setPendingApprovals(res.data.data.pending_approval || 0); })
      .catch(() => {});
    }
  }, [])

  // Update acceptedTerms when authUserData changes
  useEffect(() => {
    //Arundhati: Added check to avoid error
    if (authUserData && authUserData[0]) {
      const terms = authUserData[0].accepted_terms_and_conditions == "1" ? 1 : 0;
      setAcceptedTerms(terms);
      console.log("Updated acceptedTerms to: " + terms);

    }
  }, [authUserData])


  return (
    <>
      {
        // accepted_terms_and_conditions == 0 &&
        acceptedTerms == 0 && (
          <>
            {" "}
            <ReadPolicies action="not_close" />
          </>
        )
      }
      {is_head == 1 ||
        is_admin == 1 ||
        department_id == 5 ||
        department_id == 8 ||
        department_id == 9 ? (
        <>
          <li className="nav-item">
            <Link
              className="page-scroll"
              href="#"
              data-toggle="collapse"
              data-target="#employee-mega"
              aria-controls="employee-mega"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="pr-2">Employee</span>
              <div className="sub-nav-toggler">
                <span><i className="lni lni-chevron-down"></i></span>
              </div>
            </Link>
            <div className="sub-menu collapse mega_menu" id="employee-mega">
              <div>
                <span className="menu_heading">Employees</span>
                <ul>
                  {(is_head == 1 || is_admin == 1 || department_id == 5 || department_id == 8) && (
                    <li className="nav-item">
                      <Link className="page-scroll" to={CONST.ADMIN_PRE + "employee"}>All Employees</Link>
                    </li>
                  )}
                  <li className="nav-item">
                    <Link className="page-scroll" to={CONST.ADMIN_PRE + "employee/resignations"}>Resignations</Link>
                  </li>
                </ul>
              </div>
              <div>
                <span className="menu_heading">Leaves & Comp-Off</span>
                <ul>
                  <li className="nav-item">
                    <Link className="page-scroll" to={CONST.ADMIN_PRE + "employee/leaves/all"}>All Leaves</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="page-scroll" to={CONST.ADMIN_PRE + "employee/comp-off/all"}>All Comp-Off</Link>
                  </li>
                </ul>
              </div>
              <div>
                <span className="menu_heading">Requests</span>
                <ul>
                  <li className="nav-item">
                    <Link className="page-scroll" to={CONST.ADMIN_PRE + "requests/all"}>
                      {is_admin == 1 || department_id == 5 || department_id == 8 ? "All Requests" : "Department Requests"}
                      {pendingApprovals > 0 && (
                        <span style={{ background: '#dc2626', color: '#fff', borderRadius: '50%', padding: '1px 6px', fontSize: '0.65rem', fontWeight: 700, marginLeft: 6 }}>{pendingApprovals}</span>
                      )}
                    </Link>
                  </li>
                </ul>
              </div>
              {(is_admin == 1 || department_id == 5 || department_id == 8 || is_head == 1) && (
              <div>
                <span className="menu_heading">Assets</span>
                <ul>
                  {(is_admin == 1 || department_id == 5 || department_id == 8) && (
                    <>
                      <li className="nav-item">
                        <Link className="page-scroll" to={CONST.ADMIN_PRE + "assets/inventory"}>Inventory</Link>
                      </li>
                      <li className="nav-item">
                        <Link className="page-scroll" to={CONST.ADMIN_PRE + "assets/types"}>Asset Types</Link>
                      </li>
                      <li className="nav-item">
                        <Link className="page-scroll" to={CONST.ADMIN_PRE + "assets/brands"}>Asset Brands</Link>
                      </li>
                    </>
                  )}
                  <li className="nav-item">
                    <Link className="page-scroll" to={CONST.ADMIN_PRE + "assets/register"}>Asset Register</Link>
                  </li>
                  {(is_admin == 1 || department_id == 5 || department_id == 8) && (
                    <li className="nav-item">
                      <Link className="page-scroll" to={CONST.ADMIN_PRE + "assets/request-categories"}>Request Categories</Link>
                    </li>
                  )}
                </ul>
              </div>
              )}
              <div>
                <span className="menu_heading">Subscriptions</span>
                <ul>
                  <li className="nav-item">
                    <Link className="page-scroll" to={CONST.ADMIN_PRE + "subscriptions/all"}>Manage Subscriptions</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="page-scroll" to={CONST.ADMIN_PRE + "subscriptions/employees"}>Employee Subscriptions</Link>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </>

      ) : (
        <>
          {/* ===== Employee Nav: Holiday (direct link) ===== */}
          <li className="nav-item">
            <Link to={CONST.ADMIN_PRE + "holiday"}>
              <span className="pr-2">Holiday</span>
            </Link>
          </li>
        </>
      )}

      {is_admin == 1 || department_id == 5 ? (
        <>
          <li className="nav-item">
            <Link
              className="page-scroll "
              href="#"
              data-toggle="collapse"
              data-target="#HRD"
              aria-controls="HRD"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="pr-2">HRD</span>
              <div className="sub-nav-toggler">
                <span>
                  <i className="lni lni-chevron-down"></i>{" "}
                </span>
              </div>
            </Link>
            <div className="sub-menu collapse mega_menu" id="HRD">
              <div>
                <span className="menu_heading">Policy</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "policy-type"}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Policy Type
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "policies"}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Policy
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <span className="menu_heading">Events</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "events"}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Events
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "event-category"}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Events Category
                    </Link>
                  </li>
                </ul>
              </div>

              {/* <div>
                <span className="menu_heading">Openings</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "openings"}
                      title="openings"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Openings
                    </Link>
                  </li>
                </ul>
              </div> */}

              <div>
                <span className="menu_heading">Department</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "department"}
                      title="department"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Department
                    </Link>
                  </li>
                </ul>
              </div>
              <hr />
              <div>
                <span className="menu_heading">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                      stroke-width="0"
                      fill="currentColor"
                    ></path>
                  </svg>
                  Designation
                </span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "designation"}
                      title="designation"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Designation
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <span className="menu_heading">Testimonials</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "testimonials"}
                      title="Testimonials"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Testimonials
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <span className="menu_heading">Birthday</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "birthday"}
                      title="birthday"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Birthday
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <span className="menu_heading">Holidays</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "holidays"}
                      title="Holidays"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Holidays
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <span className="menu_heading">Quiz</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "iso-quiz/sets"}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Assignment{" "}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "iso-submissions"}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>{" "}
                      Submission{" "}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </>
      ) : department_id == 8 || is_admin == 1 ? (
        <>
          <li className="nav-item">
            <Link
              data-toggle="collapse"
              data-target="#dept"
              aria-controls="Employee"
              aria-expanded="false"
              aria-label="Toggle navigation"
              to="#"
            /* to={CONST.ADMIN_PRE + "employee"} */
            >
              <span className="pr-2">Network</span>
              <div className="sub-nav-toggler">
                <span>
                  <i className="lni lni-chevron-down"></i>{" "}
                </span>
              </div>
            </Link>
            <ul className="sub-menu collapse" id="dept">
              <li>
                <Link to={CONST.ADMIN_PRE + "department"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                      stroke-width="0"
                      fill="currentColor"
                    ></path>
                  </svg>
                  Department{" "}
                </Link>
              </li>
              <li>
                <Link to={CONST.ADMIN_PRE + "designation"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                      stroke-width="0"
                      fill="currentColor"
                    ></path>
                  </svg>{" "}
                  Designation{" "}
                </Link>
              </li>
            </ul>
          </li>
        </>
      ) : (
        <></>
      )}
      {/* {
        (is_head == 1 || is_admin == 1 || hrdStatus == 1) && (
          <>
            <li className="nav-item">
              <Link
                className="page-scroll "
                href="#"
                data-toggle="collapse"
                data-target="#Department"
                aria-controls="Department"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="pr-2">Department</span>
                <div className="sub-nav-toggler">
                  <span>
                    <i className="lni lni-chevron-down"></i>{" "}
                  </span>
                </div>
              </Link>
              <ul className="sub-menu collapse" id="Department">
                <li className="nav-item">
                  <Link
                    className="page-scroll"
                    aria-current="page"
                    to={CONST.ADMIN_PRE + "department"}
                  >
                    Department
                  </Link>
                </li>
                

                <li className="nav-item">
                  <Link
                    className="page-scroll"
                    aria-current="page"
                    to={CONST.ADMIN_PRE + "designation"}
                  >
                    Designation
                  </Link>
                </li>
              </ul>
            </li>
          </>
        )} */}

      {
        (is_admin == 1 || is_head == 1) && (
          (libraryStatus==1) &&
          (
            <li className="nav-item">
              <Link
                className="page-scroll"
                aria-current="page"
                to={CONST.ADMIN_PRE + "library"}
                title="library">Library</Link>
            </li>
          )
        )
      }
      {/* {
        (
          (is_head == 1 || is_admin == 1)
          && (
            (exemptionStatus == 1) && (

              <li className="nav-item">
                <Link
                  className="page-scroll "
                  href="#"
                  data-toggle="collapse"
                  data-target="#Exemption"
                  aria-controls="Exemption"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="pr-2"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-coin-rupee mr-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                    <path d="M15 8h-6h1a3 3 0 0 1 0 6h-1l3 3"></path>
                    <path d="M9 11h6"></path>
                  </svg>Account </span>
                  <div className="sub-nav-toggler">
                    <span>
                      <i className="lni lni-chevron-down"></i>{" "}
                    </span>
                  </div>
                </Link>
                <ul className="sub-menu collapse" id="Exemption">
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "exemption-list"}
                      title="exemption-list"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-caret-right-filled mr-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z" stroke-width="0" fill="currentColor"></path>
                      </svg>All Tax Exemption
                    </Link>
                  </li>
                </ul>
              </li>
            )
          ))
      } */}
      {/* Support menu — moved to Employee mega menu
      {(is_head == 1 || is_admin == 1 || department_id == 5 || department_id == 8) && (
      <li className="nav-item">
        <Link
          className="page-scroll "
          href="#"
          data-toggle="collapse"
          data-target="#support-mega"
          aria-controls="support-mega"
          aria-expanded="false"
          aria-label="Toggle navigation"
          to="#"
        >
          <span className="pr-2">Support</span>
          <div className="sub-nav-toggler">
            <span>
              <i className="lni lni-chevron-down"></i>{" "}
            </span>
          </div>
        </Link>
        <div
            id="support-mega"
            className="sub-menu collapse mega_menu"
          >
          <div>
            <span className="menu_heading">Subscription</span>
            <ul>
              <li className="nav-item">
                <Link to={CONST.ADMIN_PRE + "subscriptions/my"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                      stroke-width="0"
                      fill="currentColor"
                    ></path>
                  </svg>
                  Subscription Request
                </Link>
              </li>
              {(is_head == 1 || is_admin == 1) && (
                <>
                  <li className="nav-item">
                    <Link to={CONST.ADMIN_PRE + "subscriptions/all"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Manage Subscriptions
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to={CONST.ADMIN_PRE + "subscriptions/employees"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Employee Subscription List
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div>
            <span className="menu_heading">Ticket</span>
            <ul>
              <li className="nav-item">
                <Link to={CONST.ADMIN_PRE + "apply-tickets"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                      stroke-width="0"
                      fill="currentColor"
                    ></path>
                  </svg>
                  Apply Ticket
                </Link>
              </li>
              {(is_admin == 1 || is_head == 1) && (
                <li className="nav-item">
                  <Link
                    className="page-scroll"
                    aria-current="page"
                    to={CONST.ADMIN_PRE + "tickets/all"}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path
                        d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    {is_admin == 1 ? "Manage All Tickets" : "Department Tickets"}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          <div>
            <span className="menu_heading">Assets</span>
            <ul>
              <li className="nav-item">
                <Link to={CONST.ADMIN_PRE + "assets/my"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                      stroke-width="0"
                      fill="currentColor"
                    ></path>
                  </svg>
                  Asset Request
                </Link>
              </li>
              {(is_head == 1 && department_id != 8) && (
                <li className="nav-item">
                  <Link to={CONST.ADMIN_PRE + "assets/department"}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-caret-right-filled mr-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z" strokeWidth="0" fill="currentColor"></path></svg>
                    Department Assets
                  </Link>
                </li>
              )}
              {(department_id == 8 || is_admin == 1) && (
                <>
                  <li className="nav-item">
                    <Link to={CONST.ADMIN_PRE + "assets/brands"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Assets Brand
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to={CONST.ADMIN_PRE + "assets/types"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Assets Type
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to={CONST.ADMIN_PRE + "assets/all"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Assets Management
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to={CONST.ADMIN_PRE + "assets/employees"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                          d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      Employee Assets List
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </li>
      )}
      */}


      {/* Report */}
          <li className="nav-item">
            <Link
              className="page-scroll "
              href="#"
              data-toggle="collapse"
              data-target="#report-menu"
              aria-controls="report-menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="pr-2">Reports</span>

              <div className="sub-nav-toggler">
                <span>
                  <i className="lni lni-chevron-down"></i>
                </span>
              </div>
            </Link>

            <div className="sub-menu collapse mega_menu" id="report-menu">
              <div>
                <span className="menu_heading">Employee</span>
                <ul>
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "report/my-leaves-comp-off"}
                    >
                      My Leaves & Comp-Off
                    </Link>
                  </li>
                  {(is_head == 1 || is_admin == 1 || department_id == 5 || department_id == 8) && (
                  <li className="nav-item">
                    <Link
                      className="page-scroll"
                      aria-current="page"
                      to={CONST.ADMIN_PRE + "report/employee-leaves-comp-off"}
                    >
                      All Leaves & Comp-Off
                    </Link>
                  </li>
                  )}
                </ul>
              </div>
            </div>
          </li>
      {/* Setting — hidden for now
      {(is_head == 1 || is_admin == 1) && (
        <li className="nav-item">
          <Link
            className="page-scroll "
            href="#"
            data-toggle="collapse"
            data-target="#sub-nav2"
            aria-controls="sub-nav2"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="pr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-brightness-2 mr-1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
                <path d="M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"></path>
              </svg>
              Setting
            </span>
            <div className="sub-nav-toggler">
              <span>
                <i className="lni lni-chevron-down"></i>{" "}
              </span>
            </div>
          </Link>
          <ul className="sub-menu collapse" id="sub-nav2">
            <li className="nav-item">
              <Link
                className="page-scroll"
                aria-current="page"
                to={CONST.ADMIN_PRE + "permissions"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                    stroke-width="0"
                    fill="currentColor"
                  ></path>
                </svg>
                Manage Permissions
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="page-scroll"
                aria-current="page"
                to={CONST.ADMIN_PRE + "roles-responsibility"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-caret-right-filled mr-1"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z"
                    stroke-width="0"
                    fill="currentColor"
                  ></path>
                </svg>{" "}
                Roles & Responsibility
              </Link>
            </li>
          </ul>
        </li>
      )}
      */}

      {/* ===== My Requests — ALL roles, last item before profile avatar ===== */}
      <li className="nav-item">
        <Link to="#" data-toggle="collapse" data-target="#my-requests-menu" aria-controls="my-requests-menu" aria-expanded="false">
          <span className="pr-2">My Requests</span>
          <div className="sub-nav-toggler"><span><i className="lni lni-chevron-down"></i></span></div>
        </Link>
        <ul className="sub-menu collapse" id="my-requests-menu">
          <li><Link to={CONST.ADMIN_PRE + "employee/leaves/my"}>My Leaves</Link></li>
          <li><Link to={CONST.ADMIN_PRE + "employee/comp-off/my"}>My Comp-Off</Link></li>
          <li><Link to={CONST.ADMIN_PRE + "employee/leaves/all"}>Leave Approvals</Link></li>
          <li><Link to={CONST.ADMIN_PRE + "requests/my"}>My Requests</Link></li>
          <li><Link to={CONST.ADMIN_PRE + "subscriptions/my"}>My Subscriptions</Link></li>
        </ul>
      </li>
    </>
  );
}

export default AuthMenu;
